import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import "./studentDashboard.css";
import SideBar from "../commanComponents/sidebar/sidebar";
import { sidebarNavItems, COMMING_SOON_IMAGE, ROUTES } from "../../constant";
import TopNavigation from "../commanComponents/topNavigation/topNavigation";
import Calendar from 'react-calendar';
import { getAttendanceListService } from "../../modules/services";
import { clearData } from '../../utils/localStorage';


const StudentDashboard = (props) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [attendanceData, setAttendanceData] = useState([]);

    useEffect(() => {
        let date = new Date();
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const startDate = String(firstDay.getFullYear()).padStart(4, '0') + "-" + String(firstDay.getMonth() + 1).padStart(2, '0') + "-" + String(firstDay.getDate()).padStart(2, '0');
        const endDate = String(lastDay.getFullYear()).padStart(4, '0') + "-" + String(lastDay.getMonth() + 1).padStart(2, '0') + "-" + String(lastDay.getDate()).padStart(2, '0');

        (async () => {
            const responseData = await getAttendanceListService({
                pagination: "false",
                start_date: startDate,
                end_date: endDate
            });
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setAttendanceData(responseData.data);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();

    }, [navigate]);


    return (
        <div className='student-dashboard-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.dashboard} />
            <div className='student-dashboard-side-container'>
                <TopNavigation activeItem={sidebarNavItems.dashboard} />
                
                <div className='row student-dashboard-filter-container'>
                    
                </div>
                
                <div className='row student-dashboard-container-row'>
                    <div className='col student-dashboard-container-col'>
                        <div className='student-dashboard-main-container student-dashboard-right-main-container'> 
                            <div className='row'>
                                <div className='col'>
                                    <h5>Student Ranking</h5>
                                </div>
                            </div>
                            <hr className="student-dashboard-border" />
                            <div className='student-dashboard-comming-soon'>
                                <h3 className='student-dashboard-comming-soon-text'>Coming Soon</h3>
                                <img
                                    src={COMMING_SOON_IMAGE}
                                    className='student-dashboard-comming-soon-img'
                                    alt="coming soon"
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col student-dashboard-container-col'>
                        <div className='student-dashboard-main-container'>
                            <div className='row'>
                                <div className='col'>
                                    <h5>Attendance</h5>
                                </div>
                            </div>
                            <hr className="student-dashboard-border" />
                            <div className='row'>
                                <div className='col'>
                                    <Calendar
                                        calendarType='US'
                                        className="student-dashboard-calender"
                                        minDetail="year"
                                        showNeighboringMonth={false}
                                        tileContent={<CalendarTile />}
                                        tileClassName={({ activeStartDate, date, view }) => {
                                            var today = new Date();
                                            let styleClasses = "calender-tile";
                                            let attendanceStatus = "NOT_MARKED";
                                            const dateString = String(date.getFullYear()).padStart(4, '0') + "-" + String(date.getMonth() + 1).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0');
                                            const todayString = String(today.getFullYear()).padStart(4, '0') + "-" + String(today.getMonth() + 1).padStart(2, '0') + "-" + String(today.getDate()).padStart(2, '0');

                                            attendanceData.map(attendanceData => {
                                                if (attendanceData.attend_date === dateString && attendanceData.is_absent) {
                                                    attendanceStatus = "ABSENT";
                                                }
                                                else if (attendanceData.attend_date === dateString) {
                                                    attendanceStatus = "PRESENT";
                                                }
                                            })

                                            if (dateString === todayString) {
                                                styleClasses += " calender-tile-date-today";
                                            }
                                            else if (attendanceStatus === "PRESENT") {
                                                styleClasses += " calender-tile-date-present";
                                            }
                                            else if (attendanceStatus === "ABSENT") {
                                                styleClasses += " calender-tile-date-absent";
                                            }
                                            else if (date.getUTCDay() === 6) {
                                                styleClasses += " calender-tile-date-holiday";
                                            }
                                            else if (attendanceStatus === "NOT_MARKED" && dateString < todayString) {
                                                styleClasses += " calender-tile-date-not-marked";
                                            }
                                            else {
                                                styleClasses += " calender-tile-other";
                                            }

                                            return styleClasses;
                                        }}
                                        tileDisabled={({ date, view }) => view === "month" ? true : false}
                                    />
                                </div>
                                <div className='col-md calender-summary'>
                                    <div className='calender-summary-div'>
                                        <div className='calender-summary-cicle calender-summary-cicle-color-present'></div>
                                        &nbsp;<label>Attended</label>
                                    </div><br/>
                                    <div className='calender-summary-div'>
                                        <div className='calender-summary-cicle calender-summary-cicle-color-absent'></div>
                                        &nbsp;<label>Absent</label>
                                    </div><br/>
                                    <div className='calender-summary-div'>
                                        <div className='calender-summary-cicle calender-summary-cicle-color-not-marked'></div>
                                        &nbsp;<label>Not Marked</label>
                                    </div><br/>
                                    <div className='calender-summary-div'>
                                        <div className='calender-summary-cicle calender-summary-cicle-color-today'></div>
                                        &nbsp;<label>Today</label>
                                    </div><br/>
                                    <div className='calender-summary-div'>
                                        <div className='calender-summary-cicle calender-summary-cicle-color-holiday'></div>
                                        &nbsp;<label>Public Holiday</label>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <div className='student-dashboard-main-container'> 
                            <div className='row'>
                                <div className='col'>
                                    <h5>Important Notes</h5>
                                </div>
                            </div>
                            <hr className="student-dashboard-border" />
                            <div>
                                <p>&nbsp;&nbsp;&nbsp;Welcome to F.R.L. (FIRE Robotics Lab) Education Portal. Please follow these 10 golden rules while using the portal: </p>
                                <ol>
                                    <li>
                                        <p><b>*Secure Login Credentials:*</b><br/>
                                            Keep your login credentials confidential. Do not share your username and password with anyone.</p>
                                    </li>
                                    <li>
                                        <p><b>*Respect Copyright and Ownership:*</b><br/>
                                        Respect copyright rules and intellectual property rights while using educational content. Do not upload or distribute copyrighted materials without proper authorization.</p>
                                    </li>
                                    <li>
                                        <p><b>*Participate Respectfully:*</b><br/>
                                        Engage in discussions, chats, and forums with respect for others. Avoid using offensive language or engaging in disruptive behavior.</p>
                                    </li>
                                    <li>
                                        <p><b>*Complete Assignments/Quizzes Timely:*</b><br/>
                                        Submit assignments and assessments on time. Late submissions might not be accepted without valid reasons and prior communication with the instructor.</p>
                                    </li>
                                    <li>
                                        <p><b>*Active Participation:*</b><br/>
                                        Actively participate in online classes, discussions, and activities to make the most of your learning experience.</p>
                                    </li>
                                    <li>
                                        <p><b>*Data Privacy:*</b><br/>
                                        Be cautious with sharing personal information on public forums. Protect your privacy and avoid sharing sensitive details to your fellow portal friends in future.</p>
                                    </li>
                                    <li>
                                        <p><b>*System Requirements:*</b><br/>
                                        Ensure your device and internet connection meet the technical requirements for the LMS to access content seamlessly.</p>
                                    </li>
                                    <li>
                                        <p><b>*Respectful Communication:*</b><br/>
                                        Use respectful language when communicating with peers and instructors. Constructive criticism is encouraged; however, be considerate of others' feelings.</p>
                                    </li>
                                    <li>
                                        <p><b>*Be Responsible for Your Progress:*</b><br/>
                                        Regularly monitor your progress on the dashboard and address any concerns or queries with your instructors promptly.</p>
                                    </li>
                                    <li>
                                        <p><b>*Data Display Timeframe:*</b><br/>
                                        After successful login, it might take up to 72 hours for your data to fully reflect on the dashboard. If you still cannot see your data after this period, please email us with your FRL <b>(FIRE Robotics Lab)</b> ID at <b>contact@fizrobotics.com</b> for assistance.</p>
                                    </li>
                                </ol>
                                <p>&nbsp;&nbsp;&nbsp;Kindly these rules ensures a productive and respectful learning environment for all students using the FRL Education Portal. </p>
                                <p>
                                    &nbsp;&nbsp;&nbsp;IT Team,<br/> 
                                    &nbsp;&nbsp;&nbsp;FIZ Robotic Solutions
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default StudentDashboard;

const CalendarTile = () => {
    return (
        <span className='calender-tile-date-sub-class'></span>
    );
}
